import React from 'react';
import { Link } from 'react-router-dom';
import { 
  HeartIcon, 
  ChatBubbleLeftRightIcon, 
  PhotoIcon, 
  VideoCameraIcon 
} from '@heroicons/react/24/outline';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'მთავარი', href: '/' },
    { name: 'კლუბი', href: '/club' },
    { name: 'გუნდი', href: '/team' },
    { name: 'ასაკობრივი გუნდები', href: '/youth' },
    { name: 'მედია', href: '/media' },
    { name: 'გულშემატკივარი', href: '/fans' },
    { name: 'კონტაქტი', href: '/contact' }
  ];

  const clubSections = [
    { name: 'გუნდის ისტორია', href: '/club/history' },
    { name: 'ადმინისტრაცია', href: '/club/administration' },
    { name: 'ფინანსური ანგარიშგება', href: '/club/financial' },
    { name: 'სტრუქტურა', href: '/club/administration' }
  ];

  const teamSections = [
    { name: 'პირველი გუნდი', href: '/team/first-team' },
    { name: 'სამწვრთნელო შტაბი', href: '/team/coaching-staff' },
    { name: 'ტექნიკური პერსონალი', href: '/team/technical-staff' }
  ];

  return (
    <footer className="bg-gray-900 text-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Club Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="https://cup.gff.ge/sites/default/files/styles/logo_medium/public/2024-12/iveria.png?itok=FR6w_kKm" 
                alt="FC Iveria Logo" 
                className="w-10 h-10 rounded-full object-cover"
              />
              <span className="ml-3 text-xl font-bold font-georgian">
                ივერია
              </span>
            </div>
            <p className="text-gray-300 text-sm font-georgian">
              პროფესიონალური ფეხბურთის კლუბი, რომელიც მიზნად ისახავს ქართული ფეხბურთის განვითარებას და ახალგაზრდა ფეხბურთელების აღზრდას.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/khashuris.iveria.arena/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" title="Facebook">
                <HeartIcon className="h-6 w-6" />
              </a>
              <a href="https://www.tiktok.com/@iveriapliusi/video/7541348614946245906" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" title="TikTok">
                <ChatBubbleLeftRightIcon className="h-6 w-6" />
              </a>
              <a href="https://www.instagram.com/fc_iveria_khashuri_official?igsh=MWlkeWtndG5qYjBnZQ==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" title="Instagram">
                <PhotoIcon className="h-6 w-6" />
              </a>
              <a href="https://www.youtube.com/@IveriaArena" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" title="YouTube">
                <VideoCameraIcon className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-georgian">სწრაფი ბმულები</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white text-sm font-georgian transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Club Sections */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-georgian">კლუბი</h3>
            <ul className="space-y-2">
              {clubSections.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white text-sm font-georgian transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Team Sections */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-georgian">გუნდი</h3>
            <ul className="space-y-2">
              {teamSections.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white text-sm font-georgian transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-georgian">
              © {currentYear} FC ივერია. ყველა უფლება დაცულია.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm font-georgian">
                კონფიდენციალურობის პოლიტიკა
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm font-georgian">
                გამოყენების პირობები
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Absolute GFF Logo positioned relative to footer */}
      <div className="absolute right-24 top-1/3 hidden lg:block">
        <img 
          src="/gff.png" 
          alt="GFF Logo" 
          className="h-48 w-auto opacity-60 hover:opacity-80 transition-opacity duration-300"
        />
      </div>
    </footer>
  );
};

export default Footer;
